import { AxiosInstance } from "axios"
import { Admin } from "../../../../users/userTypes"
import { UserType } from "../../../../login/loginTypes"

export enum SupplierAdminsQuery {
    ADMINS_FOR_SUPPLIER = "admins-for-supplier",
}

export type FetchSupplierAdminsResponse = Readonly<{
    administrators: Admin[]
}>

type FetchSupplierAdminParams = Readonly<{
    supplierId: number
    userType: UserType | UserType[]
    isActive?: boolean
}>

export async function fetchSupplierAdmins(
    { supplierId, userType, isActive }: FetchSupplierAdminParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupplierAdminsResponse> {
    const url = `/suppliers/${supplierId}/administrators`

    const response = await axios.get(url, { params: { userType, isActive }, signal })

    return response.data
}
